import { useIntl } from 'react-intl';
import { foundation } from '../../../ui';
import CalmBanner from '../../common/notice/CalmBanner';
import { authenticatorStoreLinks } from '../../../utils/auth/authenticatorStoreLinks';

const f = foundation;
const fc = f.color;

const linksRow = { display: 'flex', flexWrap: 'wrap', alignItems: 'center', columnGap: f.spacePx[2] };
const linkStyle = (compact) => ({ color: fc.brand.text, fontWeight: f.fontWeight.semibold, textDecoration: 'underline', textUnderlineOffset: 2, display: 'inline-flex', alignItems: 'center', minHeight: compact ? 44 : undefined });

/**
 * RD-SEC-015 flow G — shown when "Open in my app" caught no app. Self-contained
 * and actionable: the two store links sit right here (the intro's "No app
 * yet?" disclosure is not on this screen). Links open in a new tab/window so
 * the enrollment in progress is never navigated away.
 */
export default function MfaNoAppNote({ compact }) {
  const intl = useIntl();
  const links = authenticatorStoreLinks();
  return (
    <CalmBanner
      tone="info"
      testId="mfa-no-app-note"
      title={intl.formatMessage({ id: 'mfaStepper.add.noAppTitle', defaultMessage: 'Nothing opened?' })}
      style={{ marginTop: f.spacePx[3] }}
    >
      {intl.formatMessage({ id: 'mfaStepper.add.noAppBody', defaultMessage: 'Get a free app, or type the key below.' })}
      <div style={linksRow}>
        <a href={links.google} target="_blank" rel="noopener noreferrer" style={linkStyle(compact)} data-testid="mfa-no-app-google">Google Authenticator</a>
        <span aria-hidden>·</span>
        <a href={links.microsoft} target="_blank" rel="noopener noreferrer" style={linkStyle(compact)} data-testid="mfa-no-app-microsoft">Microsoft Authenticator</a>
      </div>
    </CalmBanner>
  );
}
